<template>
  <div id="loader" class="tenduLoad">

    <div class="loadLogo">
      <img width="100" height="100" src="static/tendu-wb.svg">
      <p class="md-subheading">Daten werden geladen
        <div class="loader" style="position:relative; background-color:transparent;">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </p>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'loader',
  data: () => ({
    pageTitle: ' Loader ',
  }),

  computed: {
    ...mapState([
      'tenduLoading',
    ]),
  },
}

</script>

<style scoped>

.tenduLoad {
  position:fixed;
  top:0;
  z-index:300;
  height:100%;
  width:100%;
  background-color:#ffffff;
}

.loadLogo {
  position: absolute;
  text-align:center;
  top: 50%;
  left: 50%;
  width: 220px;
  height: 220px;
  margin-top: -120px; /* Half the height */
  margin-left: -110px; /* Half the width */
}

</style>
